// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {BusinessLandingScreenLayout} from 'app_components/screens/admin/landings/businessLanding'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IBusinessLandingScreenProps {}
interface IBusinessLandingScreenState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class BusinessLandingScreen extends Component<IBusinessLandingScreenProps, IBusinessLandingScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBusinessLandingScreenProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <BusinessLandingScreenLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(BusinessLandingScreen)
